import React from 'react';
import propTypes from 'prop-types';

const fallbackImg = 'https://ibassets.s3.amazonaws.com/'
  + 'static-assets/new_default_pp.svg';

function ProfilePicture({ avatar = fallbackImg }) {
  return (
    <div className="profile-sidebar__picture">
      <img
        className="profile-sidebar__image"
        src={avatar || fallbackImg}
        alt="profile"
      />
    </div>
  );
}

ProfilePicture.propTypes = {
  avatar: propTypes.string,
};

export default ProfilePicture;
